import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "Language";

/**
 * Get all available languages from API
 * @returns {Promise<Array>} Array of languages
 */
export const getAllLanguages = async () => {
    const result = await axiosInstance.get(`/${baseAPIUrl}/all`);
    return result.data;
}

/**
 * Get default language from API
 * @returns {Promise<string>} Default language code
 */
export const getDefaultLanguage = async () => {
    const result = await axiosInstance.get(`/${baseAPIUrl}/default`);
    return result.data;
}

/**
 * Get user's preferred language from API
 * @param {string|number} userId - User ID
 * @returns {Promise<string>} User's language preference
 */
export const getUserLanguage = async (userId) => {
    // Validate input
    if (!userId) {
        throw new Error('User ID is required');
    }
    
    const result = await axiosInstance.get(`/${baseAPIUrl}/user/${userId}`);
    return result.data;
}

/**
 * Get country information by language code from API
 * @param {string} languageCode - Language code (e.g., 'en', 'vi')
 * @returns {Promise<Object>} Country information
 */
export const getCountryByLanguage = async (languageCode) => {
    // Validate input
    if (!languageCode || typeof languageCode !== 'string') {
        throw new Error('Valid language code is required');
    }
    
    const result = await axiosInstance.get(`/${baseAPIUrl}/country/${languageCode}`);
    return result.data;
}

/**
 * Get supported languages from API
 * @returns {Promise<Array>} Array of supported languages
 */
export const getSupportedLanguages = async () => {
    const result = await axiosInstance.get(`/${baseAPIUrl}/supported`);
    return result.data;
}

/**
 * Get language options for UI from API
 * @returns {Promise<Array>} Array of language options
 */
export const getLanguageOptions = async () => {
    const result = await axiosInstance.get(`/${baseAPIUrl}/options`);
    return result.data;
}
